import { useCallback, useState } from 'react';

import type { NavigationLogState } from '../types';

const initialState = (date: string): NavigationLogState => ({
  date,
  passageFrom: '',
  passageTo: '',
  entries: [],
  maintenance: '',
  fuelTakenOn: ['', ''],
  waterTakenOn: ['', ''],
});

export function useNavigationLogForm(date: string) {
  const [state, setState] = useState<NavigationLogState>(() => initialState(date));
  const [logId, setLogId] = useState<string | null>(null);

  const setField = <K extends keyof NavigationLogState>(field: K, value: NavigationLogState[K]) =>
    setState((prev) => ({ ...prev, [field]: value }));

  const prefillForm = useCallback((next: NavigationLogState, id: string | null) => {
    setState(next);
    setLogId(id);
  }, []);

  const resetForm = useCallback((resetDate: string) => {
    setState(initialState(resetDate));
    setLogId(null);
  }, []);

  return {
    state,
    logId,
    setField,
    setState,
    setLogId,
    prefillForm,
    resetForm,
  };
}
